/*
 * @Author: Lucas Fridez
 * @Date: 2019-09-06 07:58:39
 * @LastEditors: Lucas Fridez
 * @LastEditTime: 2019-09-06 10:32:20
 * @Description: file content
 */
export const CATEGORIES_UPDATE = "@Categories_Update";
export const LOCATION_UPDATE = "@Location_Update";



// WEBPACK FOOTER //
// ./src/app/store/reducers/categories/ActionsCategoriesReducer.ts